import styled from "styled-components";
import { breakpoints } from "../../globalStyles";

export const ReleaseTextModalWrapper = styled.div`
  margin-top: 3%;
  align-self: baseline;
  display: grid;
  column-gap: 64px;
  grid-template-columns: 1fr 1fr;
  width: 100%;

  @media ${breakpoints.lg} {
    padding: 0 120px;
  }

  @media ${breakpoints.md} {
    grid-template-columns: 1fr;
  }

  @media ${breakpoints.xs} {
    padding: 0 16px;
  }
`;

export const StyledPodcastDetailInfo = styled.div`
  @media ${breakpoints.md} {
    display: none;
  }
`;

export const StyledReleasesList = styled.ul`
  @media ${breakpoints.md} {
    display: none;
  }
`;

export const FixedDiv = styled.div`
  position: sticky;
  top: 10%;
  left: 0;
  height: fit-content;
`;
